module.exports = __webpack_public_path__ + "img/app_android.db0a11c4.png";